import React, { Component } from 'react';

import { CardLayout, BreadCrumb, ListLayout } from './containers/Layout.jsx';
import Spin from '../../../commonModules/interface/Spin.jsx';
import InfoSAV from './SAV/InfoSAV.jsx';
import NewSAV from './SAV/NewSAV.jsx';
// import Notif from '../../../commonModules/interface/Notif.jsx';
import { TableRow, TableCell, Button, TableHead, TableBody, Typography, TextField, AppBar, Tabs, Tab, Box, Card, Grid, IconButton, Menu, MenuItem } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import { MenuRounded } from '@material-ui/icons';
import NewBin from './Recycling/NewBin.jsx';

// const list = [
//     {date:"2019/08/19", shop:"HQ", status: "over", statusName: "Retour en stock"},
//     {date:"2018/10/30", shop:"HQ", status: "waiting", statusName: "en cours de traitement"},
//     {date:"2019/07/19", shop:"HQ", status: "repairing", statusName: "en cours de réparation"},
//     {date:"2019/05/11", shop:"HQ", status: "repaired", statusName: "Réparé"},
//     {date:"2019/08/01", shop:"HQ", status: "waiting", statusName: "en cours de traitement"},
// ]
const bgColor = {
    "WAITING":"danger",
    "IN_REAPIR":"warning",
    "REPAIRED":"info",
    "BACK_IN_STOCK":"success",
}

class SAV extends Component{
    state = {
        singleSAV:{},
        singleShop:{},
        singleProduct:{},
        page: "list",
        view: "",
        breadcrumb:"",
        sav:{ },
        headerMenu: "ALL",
        notif:{
            title:"", 
            type:"", 
            message:"",
            show:false,
        },
        anchorEl: null,
    }
    componentDidMount = () => {
        this.props.getAllSAV()
    }
    handleClose = () => {
        this.setState({
            page:"list",
            breadcrumb:"",
            anchorEl: null,
            view: ""
        });
    }
    openMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget });
      };
    
      closeMenu = () => {
        this.setState({ anchorEl: null });
      };
    render () {
        console.log("[STATE] stock ",this.state.sav);
        const { PRODUCTS, SHOPS, SAV } = this.props
        const { headerMenu, anchorEl } = this.state;

        console.log("[STATE] stock ",SAV);

        return (
            <CardPage 
                title="Service Après Ventes" 
                storehouse
                action={
                    <Box>
                        {this.state.page === "list" && 
                            <Button 
                                color="primary" 
                                variant="contained"
                                onClick={ ()=> this.setState({page: "new", breadcrumb:"Nouveau"}) }
                            >Nouveau SAV</Button>
                        }
                        <IconButton 
                            aria-controls="simple-menu"
                            onClick={this.openMenu}
                        >
                            <MenuRounded />
                        </IconButton>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            getContentAnchorEl={null}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={this.closeMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={() => this.setState({page: "new", breadcrumb:"Nouveau"})}>Nouveau SAV</MenuItem>
                            <MenuItem onClick={() => this.setState({view: "newBin" })}>Nouveau bac de recyclage</MenuItem>
                        </Menu>
                    </Box>
                }
            >
                <BreadCrumb breadcrumb={this.state.breadcrumb} title="SAV" back={this.handleClose} />
                {/* {this.props.state.fetching && <Spin />} */}
                {this.state.page === "new" &&
                    <NewSAV 
                        {...this.props} 
                        closeAll={this.handleClose} 
                    />
                }
                {this.state.view === "newBin" &&
                    <NewBin 
                        {...this.props} 
                        closeAll={this.handleClose} 
                    />
                }
                {this.state.page === "suivi" && 
                    <InfoSAV 
                        {...this.props} 
                        closePopup={ 
                            () => this.setState({ page: "list", sav:{} })
                        }
                        sav={this.state.sav}
                        productName={PRODUCTS[this.state.sav.sav_product_id].name}
                        productBrand={PRODUCTS[this.state.sav.sav_product_id].marque}
                        updateSav={()=>this.props.updateSav(this.state.sav)}
                        notif={this.props.notif}
                        header={this.state.headerMenu}
                        fetchSchemas={this.props.fetchSavSchemas}
                        SAV_SCHEMAS={this.props.SAV_SCHEMAS}
                    />
                }
                
                   
                {this.state.page === "list" &&
                <Box>
                        <Tabs
                            value={this.state.headerMenu}
                            onChange={(e, tab) => this.setState({ headerMenu: tab})}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            scrollButtons="auto"
                        >
                            <Tab value="ALL" label="Tous" />
                            <Tab value="WAITING" label="En Attente" />
                            <Tab value="IN_REPAIR" label="En Réparation" />
                            <Tab value="REPAIRED" label="Réparé" />
                            <Tab value="HS" label="HS" />
                        </Tabs>
                    {/* </AppBar> */}
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th"  style={{minWidth: "150px"}}>ID</TableCell>
                                <TableCell component="th" >Produit</TableCell>
                                <TableCell component="th" >Marque</TableCell>
                                <TableCell component="th" >Quantité</TableCell>
                                <TableCell component="th" >Date du Retour</TableCell>
                                <TableCell component="th" >Dernière action</TableCell>
                                <TableCell component="th" >Shop</TableCell>
                                <TableCell component="th" >Commentaire</TableCell>
                                <TableCell component="th" >Statut</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.values(SAV[headerMenu]).map( item => (
                                <TableRow key={item.id} className={bgColor[item.status]} onClick={ 
                                    () => this.setState({ page: "suivi", sav: JSON.parse(JSON.stringify(item)) })
                                }>
                                    <TableCell ><b>{item.id.slice(0,13)}</b></TableCell>
                                    <TableCell >{PRODUCTS[item.sav_product_id].name}</TableCell>
                                    <TableCell >{PRODUCTS[item.sav_product_id].marque}</TableCell>
                                    <TableCell >{item.sav_quantity}</TableCell>
                                    <TableCell >{new Date(item.sav_time_creation).toLocaleDateString('fr-FR')}</TableCell>
                                    <TableCell >{new Date(item.sav_time_update).toLocaleDateString('fr-FR')}</TableCell>
                                    <TableCell >{SHOPS[item.sav_shop_id].name}</TableCell>
                                    <TableCell >{item.sav_actions && item.sav_actions[item.sav_actions.length - 1].action_comment}</TableCell>
                                    <TableCell >{item.sav_last_status}</TableCell>
                                </TableRow>
                            ) )}
                        </TableBody>
                    </ListLayout>
                </Box>
                }
            </CardPage>
        )
    }
}

export default SAV;